// requestIdleCallback with a setTimeout fallback for browsers without it (Safari).
export const idle = (callback: () => void) =>
  typeof requestIdleCallback === 'function' ? requestIdleCallback(callback) : setTimeout(callback, 1000);
